import styled from 'styled-components';

export default styled.button`
  border: solid;
  border-width: 2px;
  border-radius: 4px;
  padding: 0 16px;
  margin-left: 5px;
  min-width: 100px;
  font-size: 14px;
  font-weight: 500;
  height: 32px;
  background-color: #fdfdfd;
  text-transform: uppercase;
  color: ${(props) => props.theme.colors.grey[100]};
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12);

  &:hover {
    color: ${(props) => props.theme.colors.red};
    border-color: ${(props) => props.theme.colors.red};
    cursor: pointer;
  }

  &:active {
    background-color: ${(props) => props.theme.colors.grey[300]};
    color: ${(props) => props.theme.colors.primary.main};
  }
`;
